<template>
	<div class="container">

		<div class="main">
			<div class="test-list">
				<van-tabs @change="tabChange" v-model="active">
					<van-tab title="冥想放松">
						<div style="height: 15px;"></div>
						<div v-for="(item,index) in this.mxData" :key="index" class="test-item" @click="toTrain(item)">
							<img :src="item.icon_url" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">{{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #ccc;">{{parseInt(item.audio_duration/60)}}分钟</span></div>
								<div class="test-des">{{item.intro}}</div>
							</div>
						</div>
						<div class="test-item" @click="trainDetails('正念冥想')">
							<img src="../assets/images/train1.jpg" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">正念冥想&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #ccc;">9分钟</span></div>
								<div class="test-des"> 正念是指对当下体验的有意识的非评价的觉察，强调对此时此地实际身心感受接纳与觉知，并且鼓励不在这种接纳和觉知中加入评判。</div>
							</div>
						</div>
						<div class="test-item" @click="trainDetails('美人技术')">
							<img src="../assets/images/card4.png" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">美人技术&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #ccc;">7分钟</span></div>
								<div class="test-des">
									美人技术是动力沟通理论指导下的特有的以增进自我觉察为目的技术。美人技术是综合性的技术，强调存在、体验、行动、理解、目标和肯定这六个要素，按照这六个维度进行练习，面容和心灵会越来越美丽，越来越安详，越来越能觉察自己的内部的欲望、需要、情感和冲突，也越来越能觉察周围他人的欲望、需要、情感和冲突，与周围的人、事和环境会越来越协调、越来越有创造性。
								</div>
							</div>
						</div>
						<div class="test-item" @click="freedomTrain('自由练习')">
							<img src="../assets/images/card3.png" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">自由练习</div>
								<div class="test-des">如果您是一位有经验的练习者并自备了训练材料， 请进行自由练习，彼馨将为您全程记录情绪数据。 </div>
							</div>
						</div>
					</van-tab>
					<van-tab title="舒服放松">
						<div style="height: 15px;"></div>
						<div v-for="(item,index) in this.sfData" :key="index" class="test-item" @click="toTrain(item)">
							<img :src="item.icon_url" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">{{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #ccc;">{{parseInt(item.audio_duration/60)}}分钟</span></div>
								<div class="test-des">{{item.intro}}</div>
							</div>
						</div>
					</van-tab>
					<van-tab title="睡前故事">
						<div style="height: 15px;"></div>
						<div v-for="(item,index) in this.sqData" :key="index" class="test-item" @click="toTrain(item)">
							<img :src="item.icon_url" alt="" class="test-pic">
							<div class="test-info">
								<div class="test-name">{{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #ccc;">{{parseInt(item.audio_duration/60)}}分钟</span></div>
								<div class="test-des">{{item.intro}}</div>
							</div>
						</div>
					</van-tab>
				</van-tabs>

			</div>
		</div>
	</div>
</template>
<script>
	const removeDuplicateObj = (arr) => {
		let obj = {};
		arr = arr.reduce((newArr, next) => {
			obj[next.audio_id] ? "" : (obj[next.audio_id] = true && newArr.push(next));
			return newArr;
		}, []);
		return arr;
	};
	import {
		Tab,
		Tabs
	} from 'vant';
	import {
		service_resource
	} from '../api/server'
	export default {
		components: {
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
		},
		data() {
			return {
				mxData: [],
				sfData: [],
				sqData: [],
				noiseData: [],
				active: 0
			};
		},
		computed: {},
		methods: {
			freedomTrain() {
				this.$router.push({
					path: '/freedomtrain',
				})
			},
			trainDetails(type) {
				this.$router.push({
					path: '/train-main',
					query: {
						train: type
					}
				})
			},
			tabChange(n, t) {
				if (n == 1 && !this.sfData.length) {
					service_resource('{"type_id":6,"page_size":5,"page":1}', 'heartide.bixin.audio.list').then(res => {
						if (res.code == '0') {
							this.sfData = JSON.parse(res.data).data_list;
							this.relist(6);
						}
					}).catch(e => {
						console.log(e);
					})
				}
				if (n == 2 && !this.sqData.length) {
					service_resource('{"type_id":7,"page_size":5,"page":1}', 'heartide.bixin.audio.list').then(res => {
						if (res.code == '0') {
							this.sqData = JSON.parse(res.data).data_list;
							this.relist(7);
						}
					}).catch(e => {
						console.log(e);
					})
				}
			},
			toTrain(data) {
				this.$router.push({
					path: '/meditation-audio',
					query: data
				})
			},
			relist(type) {
				let list = this.$store.state.trainList;
				for (let i in list) {
					if (list[i].audio_type_id == 5 && type == 5) {
						this.mxData.push(list[i])
						this.mxData = removeDuplicateObj(this.mxData)
					}
					if (list[i].audio_type_id == 6 && type == 6) {
						this.sfData.push(list[i])
						this.sfData = removeDuplicateObj(this.sfData)
					}
					if (list[i].audio_type_id == 7 && type == 7) {
						this.sqData.push(list[i])
						this.sqData = removeDuplicateObj(this.sqData)
					}
				}
			}

		},
		created() {
			service_resource('{"type_id":5,"page_size":5,"page":1}', 'heartide.bixin.audio.list').then(res => {
				if (res.code == '0') {
					this.mxData = JSON.parse(res.data).data_list;
					this.relist(5);
				}
			}).catch(e => {
				console.log(e);
			})
		},
	};
</script>
<style lang='less' scoped>
	.container {
		min-height: 100vh;
		background-image: linear-gradient(to bottom, #E2FEFF, #F4FFF8);
	}

	.main {
		padding: 16px;
	}

	.test-item {
		background-color: #fff;
		padding: 10px;
		border-radius: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-shadow: 2px 2px 8px 0px #d9ebeb;
		margin-bottom: 16px;
	}

	.test-item img {
		max-width: 80px;
		max-height: 80px;
	}

	.test-pic {
		height: 80px;
		border-radius: 16px;
	}

	.test-info {
		/* width: 50%; */
		padding: 10px;
		max-height: 80px;
		word-wrap: break-word;
	}

	.test-name {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #2E2E2E;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}

	.test-des {
		line-height: 15px;
		font-size: 12px;
		color: #969696;
		font-weight: 500;
		height: 45px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}

	.start {
		width: 70px;
		height: 30px;
		line-height: 30px;
		border-radius: 15px;
		text-align: center;
		font-size: 12px;
		font-weight: 500;
		color: #fff;
		background-image: linear-gradient(to right, #00C8BD, #40D2DA);
	}
</style>